import React from 'react'

const SubmitBoxMessage = (props) => {
    return (
        <div className="popup-box content-info">
            <div className="box">
                {/* <span className="close-icon" onClick={(e)=>props.handleClose(e)}>x</span> */}
                {props.success ? (
                    <div className="success-job" style={{color: "#4F8A10"}}>Your Application was submitted successfully.
                        Our HR team will connect with you shortly. Thanks</div>) : (
                    <div className="job-error" style={{color: "#D8000C"}}>Oops! Error Submitting your job application.
                        Please try in some time.</div>)}
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal"
                            onClick={(e) => props.handleClose(e)}>Close
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SubmitBoxMessage;



// WEBPACK FOOTER //
// ./src/components/SubmitBoxMessage.js